import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { Router } from '@angular/router';

import { UserService } from '../../services/user.service';
import { GroupService } from '../../services/group.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.css', '../../app.component.css']
})

export class CreateUserComponent implements OnInit, OnDestroy {

    userForm: FormGroup;

    euSubs: any;

    groupForm: FormGroup;

    groups = [];
    groupsInit: any;
    groupsText = '';

    selectedGroups = [];

    initials: string[] = [];

    ggSubs: Subscription;
    initialsSub: Subscription;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private userService: UserService,
        private groupService: GroupService
    ) {
        this.loadGroups();

        this.initialsSub = userService.getUsers().subscribe(users => {
            this.initials = users.map(({initials}) => initials);
            console.log(this.initials);
        });
    }

    ngOnInit() {
        this.userForm = this.formBuilder.group({
            name: ['', Validators.required],
            lastName: ['', Validators.required],
            initials: ['', [Validators.required, Validators.maxLength(3)]],
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
            confirmPassword: ['', Validators.required]
        });

        this.groupForm = this.formBuilder.group({
            groupId: ['', Validators.required]
        });
    }
    ngOnDestroy() {
        this.ggSubs.unsubscribe();
        this.initialsSub.unsubscribe();
    }

    onSubmitUser() {
        let {confirmPassword, ...user} = this.user;

        if(!user.groups.length) return toast('Seleccione al menos un grupo.', 3000);
        if(user.password !== confirmPassword) return toast('Las contraseñas no coinciden.', 3000);
        if(this.initials.find(initial => initial == user.initials)) return toast('Las iniciales ya pertenecen a otro usuario.', 3000);
        
        let userSub = this.userService.getUserByEmail(user.email).subscribe(([userObj]) => {
            userSub.unsubscribe();
            if(!userObj) this.userService.addUser(user);
            else toast('Este correo electrónico ya está registrado.');
        });
    }

    get user() {
        const currentDate = new Date();

        const groupsArray = [];

        for (let item in this.selectedGroups) {
            groupsArray.push(this.selectedGroups[item].groupId);
        }

        const userJson = {
            email: this.userForm.get('email').value,
            groups: groupsArray,
            lastName: this.userForm.get('lastName').value,
            name: this.userForm.get('name').value,
            initials: this.userForm.get('initials').value,
            password: this.userForm.get('password').value,
            confirmPassword: this.userForm.get('confirmPassword').value,
            photoUrl: '',
            createdAt: currentDate,
            updatedAt: currentDate
        };

        return userJson;
    }

    addGroup({ value, valid }: { value: any, valid: boolean }) {
        value.groupName = value.groupId;
        value.groupId = this.groups[value.groupId];

        if (value.groupId !== undefined) {
            if (this.selectedGroups.find(x => x.groupId === value.groupId) === undefined) {
                this.selectedGroups.push(value);
            }

            this.groupForm.reset();
        }
    }

    deleteGroup(index) {
        this.selectedGroups.splice(index, 1);
    }

    loadGroups() {
        this.ggSubs = this.groupService.getGroups().subscribe(tempGroups => {
            const dataGroup = {};

            for (const idx in tempGroups) {
                dataGroup[tempGroups[idx].name.trim()] = null;
                this.groups[tempGroups[idx].name.trim()] = tempGroups[idx].id$;
            }

            this.groupsInit = { 'data': dataGroup };
        });
    }

    onBlurGroup() {
        if (this.groups[this.groupsText] === undefined) {
            this.groupsText = '';
        }
    }


}
